export default __webpack_public_path__ + "static/media/COMMUNITY.3454dbcc.png";